import { jsx as _jsx } from "react/jsx-runtime";

function SvgPdf() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.777 3c0-1.471 1.127-3 3-3h10.171a3 3 0 012.122.879l3.828 3.828a3 3 0 01.879 2.121V21c0 .827-.271 1.6-.844 2.166-.571.566-1.348.834-2.183.834H4.777c-.836 0-1.61-.269-2.177-.84-.565-.571-.823-1.343-.823-2.16V3zm3-1c-.613 0-1 .471-1 1v18c0 .398.12.626.244.752.123.124.349.248.756.248H18.75c.408 0 .644-.125.776-.255.13-.13.25-.357.25-.745V8h-4a2 2 0 01-2-2V2h-9zm11 .414L19.363 6h-3.586V2.414zM7.593 15.553V17H6.565v-4.266h1.702c.326 0 .614.06.864.182.252.12.447.29.583.513.139.22.208.471.208.753 0 .416-.15.749-.448.999-.297.248-.705.372-1.224.372h-.657zm0-.794h.674c.2 0 .35-.05.454-.15.106-.1.158-.24.158-.421 0-.2-.053-.359-.16-.478a.57.57 0 00-.44-.182h-.686v1.23zM10.473 17v-4.266h1.374c.377 0 .716.086 1.017.258.3.17.535.411.703.724.17.31.256.659.258 1.046v.196c0 .39-.083.741-.25 1.052a1.81 1.81 0 01-.697.726 1.977 1.977 0 01-1.002.264h-1.403zm1.028-3.472v2.681h.358c.295 0 .521-.104.68-.313.158-.211.237-.524.237-.938v-.185c0-.412-.08-.722-.237-.931-.159-.21-.39-.314-.692-.314h-.345zm3.88 1.773h1.658v-.791H15.38v-.982h1.826v-.794h-2.854V17h1.028v-1.7z"
    }, void 0)
  }), void 0);
}

export default SvgPdf;